export default __webpack_public_path__ + "assets/front/scss/common.973979dd1bef1af2aa98e462e82e5c8e.css";